import { render, staticRenderFns } from "./wisdomWater.vue?vue&type=template&id=5a83d3fc&scoped=true&"
import script from "./wisdomWater.vue?vue&type=script&lang=js&"
export * from "./wisdomWater.vue?vue&type=script&lang=js&"
import style0 from "./wisdomWater.vue?vue&type=style&index=0&id=5a83d3fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83d3fc",
  null
  
)

export default component.exports